import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5528_29309)">
      <path d="M24 0H0V24H24V0Z" fill="#ECEDEE" />
      <path
        d="M11.9999 23.9203C18.5833 23.9203 23.9202 18.5834 23.9202 12C23.9202 5.41662 18.5833 0.0797119 11.9999 0.0797119C5.4165 0.0797119 0.0795898 5.41662 0.0795898 12C0.0795898 18.5834 5.4165 23.9203 11.9999 23.9203Z"
        fill="#ECEDEE"
      />
      <path
        d="M17.8312 12.5906L22.064 8.35779L11.9999 12.3797L1.93115 8.35779L6.16396 12.5906C6.4874 12.914 6.92334 13.0969 7.38271 13.0969H9.1874L6.6374 15.6468L11.9905 13.4812L17.3437 15.6468L14.7937 13.0969H16.5983C17.0577 13.0969 17.4937 12.914 17.8171 12.5906H17.8312Z"
        fill="#151718"
      />
    </g>
    <defs>
      <clipPath id="clip0_5528_29309">
        <rect width="24" height="24" rx="4" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
